import React, { useState } from "react";
import logo from "./../../../../shared/images/c2s-logo-white.png";
import { Button } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { auth } from "../../../../shared/services/firebase";
import { Formik } from "formik";

import {
  Container,
  CustomLink as Link,
  Logo,
  Input,
  Form,
  Alert,
} from "./styles";

export const Login = function () {
  const history = useHistory();
  const [alertError, setAlertError] = useState(null);

  const { t } = useTranslation(["Login", "common"]);

  return (
    <Container>
      <Formik
        initialValues={{ email: "", password: "" }}
        validate={(values) => {
          const errors = {};
          if (!values.email) {
            errors.email = t("common:errors.required");
          } else if (
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
          ) {
            errors.email = t("common:errors.invalid");
          }

          if (!values.password) {
            errors.password = t("common:errors.required");
          }

          return errors;
        }}
        onSubmit={async function (values) {
          setAlertError("");

          try {
            await auth.signInWithEmailAndPassword(
              values.email,
              values.password
            );

            window.location.href = "/";
          } catch (error) {
            if (
              ["auth/user-not-found", "auth/wrong-password"].includes(
                error.code
              )
            ) {
              setAlertError(t("errors.auth"));
            } else {
              setAlertError(error.message);
            }
          }
        }}
      >
        {({ values, handleChange, errors, handleSubmit }) => (
          <Form onSubmit={handleSubmit} noValidate autoComplete="off">
            <Logo src={logo} alt="Logo C2S" />

            {alertError && (
              <Alert variant="filled" severity="error">
                {alertError}
              </Alert>
            )}

            <Input
              id="email"
              data-testid="email"
              label={t("label.email")}
              variant="filled"
              name="email"
              type="email"
              value={values.email}
              helperText={errors.email}
              onChange={handleChange}
            />

            <Input
              id="password"
              data-testid="password"
              label={t("label.password")}
              variant="filled"
              type="password"
              name="password"
              value={values.password}
              helperText={errors.password}
              onChange={handleChange}
            />

            <Button
              data-testid="submitButton"
              variant="contained"
              color="default"
              type="submit"
            >
              {t("submit")}
            </Button>
            <Link to="/authentication/password_recovery">
              Esqueci minha senha
            </Link>
          </Form>
        )}
      </Formik>
    </Container>
  );
};
